module.exports = __webpack_public_path__ + "6ad7591bc480207145e0109ad7ea7017.svg";